import getBookmakersConfig from "./bookmakers";
import { actionTypes as bookmakersListActionTypes } from "./bookmakersList.actions";
import bookmakerReducer from "./bookmakersListItem.reducer";
import updateUserAccountsInfoStorage from "../utils/userAccountsInfo";
import { actions as pageInfoActions } from "../pageInfo";
import { bookmakerNames } from "../utils/constants/bookmakers";

const bookmakers = getBookmakersConfig();
const pageInfoActionTypes = pageInfoActions.actionTypes;

// Purpose: Function for creating redirect URLs to tackle AdBlockers
// /redirect/ is actual Janus NextJS page!!!
const createRedirectUrl = (url, name) =>
    `/redirect/?url=${encodeURIComponent(url)}&name=${name}`

export default function bookmakersListReducer(state = bookmakers, action) {
    switch (action.type) {
        case bookmakersListActionTypes.USER_INFO_REQUESTING:
        case bookmakersListActionTypes.SET_USER_INFO:
        case bookmakersListActionTypes.SET_USER_INFO_ERROR:
        case bookmakersListActionTypes.SET_AUTH_INFO:
        case bookmakersListActionTypes.SET_LOGGEDOUT:
            return state.map((bookmaker) => {
                if (bookmaker.feed === action.feed) {
                    return bookmakerReducer(bookmaker, action);
                }
                return bookmaker;
            });
        case bookmakersListActionTypes.SET_LOGGEDIN_BOOKMAKERS:
            return state.map((bookmaker) => {
                if (action.feeds.includes(bookmaker.feed)) {
                    return bookmakerReducer(bookmaker, action);
                }
                return bookmaker;
            });
        case bookmakersListActionTypes.SET_LOGIN_SUCCESS:
            return state.map((bookmaker) => {
                if (bookmaker.feed === action.feed) {
                    updateUserAccountsInfoStorage(bookmaker, true);
                    return {
                        ...bookmaker,
                        isLoggedIn: true,
                        justLoggedIn: true,
                    };
                }
                return {
                    ...bookmaker,
                    justLoggedIn: false,
                };
            });
        case bookmakersListActionTypes.CLEAR_JUST_LOGGEDIN:
            return state.map((bookmaker) => ({
                ...bookmaker,
                justLoggedIn: false,
            }));
        case pageInfoActionTypes.APP_CONFIG_RECEIVED: {
            const targetDevice = action.isPhone ? "mobile" : "desktop";

            const bookmakersConfig = action.config.data.bookmakerOffersTierOne;

            const betslipBookmakers = state.map((bookmaker) => {
                const {
                    name,
                    offer,
                    alt_offer,
                    linkText,
                    sign_up_link_1,
                    sign_up_link_2,
                    sign_up_link_3,
                    sign_up_link_9,
                    bookmaker_terms_conditions,
                    tsAndCs,
                    Top_up_bookie_name,
                    Top_up_bookie_url,
                    Withdraw_bookie_url,
                    Withdraw_bookie_name,
                    Forgotten_bookie_url
                } = bookmakersConfig[bookmaker.dynamicDataKey][targetDevice];

                const isWilliamHill = name === "William Hill";
                const isMobile = targetDevice === "mobile";
                const bookmakerRegLink = isMobile
                    ? createRedirectUrl(sign_up_link_3, name)
                    : createRedirectUrl(sign_up_link_9, name);
                const bookmakerOfferLink = isMobile
                    ? createRedirectUrl(sign_up_link_1, name)
                    : createRedirectUrl(sign_up_link_2, name);

                const pageInfo = {
                    ...bookmaker,
                    registrationOfferHeadline: alt_offer || offer,
                    registrationOffer: tsAndCs,
                    registrationOfferLinkText: linkText,
                    registrationOfferLinkUrl: createRedirectUrl(sign_up_link_1, name),
                    promoCode: null,
                    registrationOfferDetailsLink: bookmakerOfferLink,
                    termsAndConditionsLink: bookmaker_terms_conditions,
                    registrationLink: bookmakerRegLink,
                    withdrawBookmakerName: Withdraw_bookie_name || null,
                    withdrawBookmakerUrl: Withdraw_bookie_url || null,
                    forgottenPhoneNumber: null,
                    forgottenBookmakerName: isWilliamHill
                        ? "www.willhill.com"
                        : null,
                    forgottenBookmakerUrl: Forgotten_bookie_url || null,
                    shouldNotRender: false,
                };

                /* eslint-disable camelcase */
                if (Top_up_bookie_url !== null && Top_up_bookie_name !== null) {
                    pageInfo.topUpBookmakerName = Top_up_bookie_name;
                    pageInfo.topUpBookmakerUrl = Top_up_bookie_url;
                }
                /* eslint-enable camelcase */

                return pageInfo;
            });

            const nonBetslipBookmakers = [
                {
                    name: bookmakerNames.bestOdds,
                    feed: "#BESTODDS",
                    displayName: "Best Odds",
                    shouldNotRender: true,
                    availableOnPhone: true,
                },
                // Note:
                // We only comment the bookmaker for now.
                // If in future SSG don't work with it, we will delete the bookmaker
                // {
                //     name: "SportingBet",
                //     feed: "SPORTING INDEX",
                //     displayName: "Sporting Bet",
                //     shouldNotRender: true,
                //     availableOnPhone: false,
                // },
                {
                    name: bookmakerNames.betfred,
                    feed: 'BETFRED',
                    displayName: 'Betfred',
                    shouldNotRender: true,
                    availableOnPhone: false,
                },
                {
                    name: bookmakerNames.boyleSports,
                    feed: "BOLEYSPORTS",
                    displayName: "Boyle Sports",
                    shouldNotRender: true,
                    availableOnPhone: false,
                },
                {
                    name: bookmakerNames.betVictor,
                    feed: "VC",
                    displayName: "Bet Victor",
                    shouldNotRender: true,
                    availableOnPhone: false,
                },
                {
                    name: bookmakerNames.tote,
                    feed: "TOTE",
                    displayName: "TOTE",
                    shouldNotRender: true,
                    availableOnPhone: false,
                },
            ];

            return [...betslipBookmakers, ...nonBetslipBookmakers];
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /src/js/common/bookmakersList/bookmakersList.reducer.js